import { render } from "./AdmitCardPrint.vue?vue&type=template&id=3a76b772&scoped=true"
import script from "./AdmitCardPrint.vue?vue&type=script&lang=js"
export * from "./AdmitCardPrint.vue?vue&type=script&lang=js"

import "./AdmitCardPrint.vue?vue&type=style&index=0&id=3a76b772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a76b772"]])

export default __exports__